import React from 'react';
import './../quizz/style/fonts.module.css'

const CustomButton = ({
  text,
  onClick,
  icon,
  iconPosition,
  outline,
  bold,
  big,
  disabled,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${big ? 'w-[180px]' : 'w-[150px]'} ${
        disabled 
          ? 'bg-gray-300 cursor-not-allowed' 
          : 'bg-gradient-to-r from-[#FF8036] to-[#FFA35E] hover:from-[#FFA35E] hover:to-[#FF8036]'
      } text-white rounded-md px-4 py-2 transition-all duration-300`}
    >
      {icon && iconPosition === 'left' && icon}
      {text}
      {icon && iconPosition === 'right' && icon}
    </button>
  );
};

export default CustomButton;